import routes from '@config/routes.json';
import BaseLogo from '@base/BaseLogo';
import BaseSemanticLink from '@base/BaseSemanticLink';
import useI18n from '@i18n';

import useHeaderData from '@hooks/useHeaderData/useHeaderData';
import buildHeaderNavContext from '@layout/Header/utils/buildHeaderNavContext';
import BurgerMenu from '../BurgerMenu';
import CurrencySwitch from '../CurrencySwitch';
import HeaderShell from '../Header';
import ManagerMenu from '../ManagerMenu';
import NavBar from '../NavBar';
import NotificationsMenu from '../NotificationsMenu';
import UserMenu from '../UserMenu';
import UserProfile from '../UserMenu/UserProfile';

interface IAuthHeaderProps {
    className?: string;
}

const AuthHeader: React.FC<IAuthHeaderProps> = ({ className }) => {
    const { locale } = useI18n();
    const data = useHeaderData();
    const navContext = buildHeaderNavContext(true, locale, data);

    return (
        <HeaderShell
            className={className}
            mobileNav={
                <BurgerMenu navContext={navContext}>
                    <BaseSemanticLink to={routes.profile}>
                        <UserProfile profile={data.profile} />
                    </BaseSemanticLink>
                </BurgerMenu>
            }
            left={
                <>
                    <div className="shrink-0">
                        <BaseLogo link="/" />
                    </div>
                    <div className="flex-1 hidden h-full min-w-0 md:flex md:items-stretch">
                        <NavBar navContext={navContext} />
                    </div>
                </>
            }
            right={
                <>
                    <ManagerMenu manager={data.manager} unreadCount={data.supportUnreadCount} />
                    <NotificationsMenu notifications={data.notifications} />
                    <CurrencySwitch
                        currentCurrency={data.currentCurrency}
                        setCurrentCurrency={data.setCurrentCurrency}
                    />
                    <div className="hidden h-full md:flex md:items-stretch whitespace-nowrap">
                        <UserMenu profile={data.profile} navContext={navContext} />
                    </div>
                </>
            }
        />
    );
};

export default AuthHeader;
